'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactShare = require('react-share');
var _reactCopyToClipboard = require('react-copy-to-clipboard');
var _isSameElement = require('../../helpers/isSameElement');var _isSameElement2 = _interopRequireDefault(_isSameElement);
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _ShareTooltip = require('./ShareTooltip.scss');var styles = _interopRequireWildcard(_ShareTooltip);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
var WhatsappIcon = (0, _reactShare.generateShareIcon)('whatsapp');var
FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton;

var whatsAppMessage = {
  he: 'מצאתי דירה מעניינת ב- און מאפ שחשבתי שתעניין אותך:',
  en: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:',
  ru: 'Я нашел интересную квартиру на OnMap.co.il, которая, как я думал, заинтересует вас:',
  fr: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:' };


var emailMessage = {
  he: { subject: 'דירה מעניינת ב- און מאפ', message: 'מצאתי דירה מעניינת ב- און מאפ שחשבתי שתעניין אותך:' },
  en: { subject: 'Interesting apartment on OnMap.co.il', message: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:' },
  ru: { subject: 'Интересная квартира на OnMap.co.il', message: 'Я нашел интересную квартиру на OnMap.co.il, которая, как я думал, заинтересует вас:' },
  fr: { subject: 'Interesting apartment on OnMap.co.il', message: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:' } };var


ShareTooltip = function (_Component) {_inherits(ShareTooltip, _Component);function ShareTooltip() {var _temp, _this, _ret;_classCallCheck(this, ShareTooltip);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      linkCopied: false }, _this.














    bodyClickHandler = function (evt) {
      if (!_this.props.isTooltipShown) {
        return;
      }
      if (!(0, _isSameElement2.default)(_this.node, evt.target)) {
        evt.stopPropagation();
        _this.props.hideTooltip();
      }
    }, _this.

    trackShareClick = function () {return (
        new Promise(function (resolve) {
          resolve((0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.share, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.contactDetails));
        }));}, _this.

    tooltipClickHandler = function () {var _this$props =
      _this.props,isMobile = _this$props.isMobile,hideModalShare = _this$props.hideModalShare,hideTooltip = _this$props.hideTooltip;
      var closeTooltip = isMobile ? hideModalShare : hideTooltip;

      if (_this.closeWithTimeout) {
        setTimeout(closeTooltip, 2000);
      } else {
        closeTooltip();
      }
    }, _this.

    handleCopyLink = function () {
      _this.closeWithTimeout = true;
      _this.setState({ linkCopied: true });
    }, _this.

    renderShareEmail = function (sharingUrl) {var _emailMessage$_this$p =
      emailMessage[_this.props.locale],subject = _emailMessage$_this$p.subject,message = _emailMessage$_this$p.message;
      var link = 'mailto:?subject=' + subject + '&body=' + message + ' ' + sharingUrl;
      return (
        _react2.default.createElement('a', { href: link, className: styles.shareRow },
          _react2.default.createElement('div', { className: styles.iconWrapper },
            _react2.default.createElement('span', { className: 'icon icon-mailIcon' })),


          _react2.default.createElement('span', null, _this.props.emailTitle)));


    }, _temp), _possibleConstructorReturn(_this, _ret);}ShareTooltip.prototype.componentDidMount = function componentDidMount() {if (!this.props.isMobile) {document.body.addEventListener('click', this.bodyClickHandler);}};ShareTooltip.prototype.componentWillUnmount = function componentWillUnmount() {if (!this.props.isMobile) {document.body.removeEventListener('click', this.bodyClickHandler);}};ShareTooltip.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,sharingUrl = _props.sharingData.sharingUrl,isMobile = _props.isMobile;
    var protocol = sharingUrl.includes('://') ? '' : 'https://';
    var shareText = encodeURIComponent(whatsAppMessage[this.props.locale]) + ' ' + protocol + sharingUrl;

    var whatsappLink = isMobile ? 'whatsapp://send?text=' +
    shareText : 'https://api.whatsapp.com/send?text=' +
    shareText;
    return (
      _react2.default.createElement('div', {
          onClick: this.tooltipClickHandler,
          className: (0, _classnames2.default)(isMobile ? styles.shareWrapper : styles.tooltipWrapper, styles[this.props.className]),
          ref: function ref(node) {_this2.node = node;} },

        _react2.default.createElement('div', { className: styles.shareRow },
          _react2.default.createElement(FacebookShareButton, {
              url: protocol + sharingUrl,
              beforeOnClick: this.trackShareClick },

            _react2.default.createElement('div', { className: styles.iconWrapper },
              _react2.default.createElement(FacebookIcon, { size: 35, round: true })),

            _react2.default.createElement('span', null, 'Facebook'))),



        _react2.default.createElement('a', {
            className: styles.shareRow,
            href: whatsappLink,
            target: '_blank',
            'data-action': 'share/whatsapp/share' },

          _react2.default.createElement('div', { className: styles.iconWrapper },
            _react2.default.createElement(WhatsappIcon, { size: 35, round: true })),

          _react2.default.createElement('span', null, 'WhatsApp')),


        _react2.default.createElement(_reactCopyToClipboard.CopyToClipboard, {
            text: sharingUrl && ('' + protocol + sharingUrl).replace(/www./g, ''),
            onCopy: this.handleCopyLink },

          _react2.default.createElement('div', { className: styles.shareRow },
            _react2.default.createElement('div', { className: styles.iconWrapper },
              _react2.default.createElement('div', { className: styles.copyLinkWrap },
                _react2.default.createElement('span', { className: 'icon icon-copy-link' },
                  _react2.default.createElement('span', { className: 'path1' }),
                  _react2.default.createElement('span', { className: 'path2' }),
                  _react2.default.createElement('span', { className: 'path3' })))),



            _react2.default.createElement('div', { className: styles.copyLink },
              _react2.default.createElement('span', null, this.props.copyLinkTitle),
              this.state.linkCopied &&
              _react2.default.createElement('span', { className: 'icon icon-circled-check' },
                _react2.default.createElement('span', { className: 'path1' }),
                _react2.default.createElement('span', { className: 'path2' }))))),





        this.renderShareEmail(sharingUrl)));


  };return ShareTooltip;}(_react.Component);exports.default = ShareTooltip;


ShareTooltip.propTypes = {
  locale: _propTypes2.default.string,
  emailTitle: _propTypes2.default.string,
  className: _propTypes2.default.string,
  copyLinkTitle: _propTypes2.default.string,
  sharingData: _propTypes2.default.object,
  hideTooltip: _propTypes2.default.func,
  isTooltipShown: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  hideModalShare: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareTooltip/ShareTooltip.js
// module id = 2904
// module chunks = 0